/**
 * Жетон уровня личного рейтинга (RE1): шестигранник pointy-top с номером.
 * Тиры: 1-3 графит · 4-6 сталь · 7-9 золото · 10 — золотая заливка со
 * свечением. `dashed` — состояние «нет игр» (пунктир + «—»).
 * Цвета — в theme.css (.hexbadge--*), высота = ширина × 26/24.
 */
export function HexBadge({
  level,
  size = 24,
  dashed = false,
}: {
  level: number;
  size?: number;
  dashed?: boolean;
}) {
  const tier = dashed
    ? 'dashed'
    : level >= 10
      ? 'max'
      : level >= 7
        ? 'gold'
        : level >= 4
          ? 'steel'
          : 'graphite';
  const h = (size * 26) / 24;
  const stroke = size >= 30 ? 2 : 1.5;
  const label = dashed ? '—' : String(level);
  const fontSize = 24 * (label.length > 1 ? 0.4 : 0.5); // в координатах viewBox
  return (
    <svg
      className={`hexbadge hexbadge--${tier}`}
      width={size}
      height={h}
      viewBox="0 0 24 26"
      aria-label={dashed ? 'Нет уровня' : `Уровень ${level}`}
    >
      <path
        d="M12 1.3l10.2 5.9v11.6L12 24.7 1.8 18.8V7.2z"
        strokeLinejoin="round"
        strokeWidth={(stroke * 24) / size}
        strokeDasharray={dashed ? '3 3' : undefined}
      />
      <text
        x="12"
        y="13.5"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={fontSize}
        fontFamily="var(--font-mono)"
        fontWeight={700}
        letterSpacing="-0.03em"
        stroke="none"
      >
        {label}
      </text>
    </svg>
  );
}
